import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import Clients from '../../../../components/portalComponents/clients';

import { setPageTitle } from '../../../../redux/title/title.slice';
import { clearClients, getPracticeClients } from '../../../../redux/clients/clients.slice';
import { getProviders } from '../../../../redux/providers/providers.slice';

function PracticeClients() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    clients = [],
    loadingClients,
    pageIndex = 0, // 👈 from API (0-based)
    totalPages = 1,
    totalCount = 0
  } = useSelector((state) => state.clients);

  const { providers = [] } = useSelector((state) => state.providers);

  const ACTIVE_FLAG = 8192;

  const activeProviders = providers
    .filter((p) => (p.clientStatusFlags & ACTIVE_FLAG) === 0)
    .sort((a, b) => a.clientName.localeCompare(b.clientName));

  useEffect(() => {
    dispatch(setPageTitle('Clients'));
    dispatch(getProviders());
  }, [dispatch]);

  // 🔍 SEARCH
  const handleSearch = (payload) => {
    dispatch(clearClients());
    dispatch(
      getPracticeClients({
        ...payload,
        pageIndex: 0 // always reset to first page
      })
    );
  };

  // 🔄 PAGINATION
  const handlePageChange = (payload) => {
    dispatch(getPracticeClients(payload));
  };

  // 🧹 CLEAR
  const handleClear = () => {
    dispatch(clearClients());
  };

  // 👁 VIEW
  const handleViewClient = (client) => {
    navigate(`/practice/clients/${client.id}`);
  };

  return (
    <Box width="100%" mb={4}>
      <Clients
        clients={clients}
        loading={loadingClients}
        providers={activeProviders}
        pageIndex={pageIndex}
        totalPages={totalPages}
        totalCount={totalCount}
        onSearch={handleSearch}
        onPageChange={handlePageChange}
        onClear={handleClear}
        onViewClient={handleViewClient}
      />
    </Box>
  );
}

export default PracticeClients;
